// @flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

import type Painter from "../../render/painter";
import type SourceCache from '../../source/source_cache';
import type RasterStyleLayer from '../../style/style_layer/raster_style_layer';
import type { OverscaledTileID } from '../../source/tile_id';
import ImageSource from '../../source/image_source';
import RenderRaster from "./plotty-render/index";
import StencilMode from '../../gl/stencil_mode';
import DepthMode from '../../gl/depth_mode';
// const drawLerc = require('./draw_lerc_util').default;

export default drawRaster;
/**
 * å¸®å©äº§çä¸è§ç½é¡¶ç¹æ°æ®çç±»
 * @class VaoHelper
 */
class VaoHelper {
    static bind(gl, program) {
        if (gl !== VaoHelper.gl) {
            VaoHelper.gl = gl;
        }

        if (program !== VaoHelper.program) {
            VaoHelper.program = program;
        }

        return VaoHelper;
    }
    static getVao({ tileSize, pixels, vertexType }) {
        const key = JSON.stringify({ tileSize, pixels, vertexType });
        if (VaoHelper.cache[key]) {
            return VaoHelper.cache[key];
        }
        const isBar = vertexType === 'bar';
        VaoHelper.cache[key] = VaoHelper.createVao(tileSize, pixels, isBar);
        return VaoHelper.cache[key];
    }
    static createVao(tileSize, pixels, isBar) {
        const gl = VaoHelper.gl;
        const program = VaoHelper.program;
        if (!gl) return console.warn('VaoHelper require bind gl');
        if (!program) return console.warn('VaoHelper require bind program');
        const { arrayBuffer, elementBuffer, elementLength } = VaoHelper.createBuffer(tileSize, pixels, isBar);
        return VaoHelper.creatVaoBuffer({ gl, program, arrayBuffer, elementLength, elementBuffer });
    }
    static createBuffer(tileSize, pixel, isBar) {
        const row = (tileSize / pixel) + 1;
        const column = row;
        // const arrayBuffer =  new Float32Array(row*row*2);
        const arrayBuffer = [];
        const elementBuffer = [];
        for (let i = 0; i < row; i += 2) {
            for (let j = 0; j < column; j++) {
                let currentRow = i;
                const currentColumn = j;
                arrayBuffer.push(pixel * currentColumn);
                arrayBuffer.push(pixel * currentRow);
                arrayBuffer.push(1.0);
                if (i + 1 < row) {
                    currentRow = i + 1;
                    arrayBuffer.push(pixel * currentColumn);
                    arrayBuffer.push(pixel * currentRow);
                    arrayBuffer.push(1.0);
                }
            }
        }
        for (let i = 0; i < row - 1; i++) {

            let begin = Math.floor(i / 2) * column * 2 + i % 2;
            if (i !== 0) {
                VaoHelper.backTriangle(elementBuffer, begin);
            }
            const step = i % 2 === 0 ? 1 : 2 * column - 1;
            if (i === row - 2 && i % 2 !== 0) {
                let lastRowBegin = begin + step;
                for (let j = 0; j < column; j++) {
                    elementBuffer.push(begin);
                    elementBuffer.push(lastRowBegin);
                    lastRowBegin += 1;
                    begin += 2;
                }
                continue;
            }
            for (let j = 0; j < column; j++) {
                elementBuffer.push(begin);
                elementBuffer.push(begin + step);
                begin += 2;
            }
        }
        // const length = elementBuffer.length;
        if (isBar) {
            VaoHelper.createBaseBuffer({ row, elementBuffer, arrayBuffer });
        }
        return {
            arrayBuffer: new Float32Array(arrayBuffer),
            elementBuffer: new Uint16Array(elementBuffer),
            elementLength: elementBuffer.length,
        };
    }
    static createBaseBuffer({ row, elementBuffer, arrayBuffer }) {
        const funs = {
            left: v => (v % 2 === 0 ? 1 : 2 * row - 1),
            down: () => 1,
            right: v => {
                if (v === 0) return -1 * row;
                else return (v % 2 !== 0 ? -1 : -1 * (2 * row - 1));

            },
            up: () => -2,
        };
        let begin = 0;
        const firstBase = arrayBuffer.length / 3;
        VaoHelper.backTriangle(elementBuffer, begin);
        ['left', 'down', 'right', 'up'].forEach(position => {
            begin = Math.floor(begin);
            const fun = funs[position];
            for (let i = 0; i < row - 1; i++) {
                const step = fun(i);
                const x = arrayBuffer[begin];
                const y = arrayBuffer[begin + 1];
                arrayBuffer.push(x);
                arrayBuffer.push(y);
                let baseIndex = arrayBuffer.push(0);
                baseIndex = (baseIndex - 3) / 3;
                elementBuffer.push(begin / 3);
                elementBuffer.push(baseIndex);
                begin += step * 3;
            }
        });
        elementBuffer.push(0);
        elementBuffer.push(firstBase);

    }
    static creatVaoBuffer({ gl, program, arrayBuffer, elementBuffer, elementLength, attribute = 'a_pos' }) {
        if (gl.extVertexArrayObject === undefined) {
            gl.extVertexArrayObject = gl.getExtension("OES_vertex_array_object");
        }
        const vao = gl.extVertexArrayObject.createVertexArrayOES();
        gl.extVertexArrayObject.bindVertexArrayOES(vao);

        const buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferData(gl.ARRAY_BUFFER, arrayBuffer, gl.STATIC_DRAW);

        const indexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, elementBuffer, gl.STATIC_DRAW);

        const a_attribute = gl.getAttribLocation(program, attribute);
        gl.vertexAttribPointer(a_attribute, 3, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(a_attribute);
        gl.extVertexArrayObject.bindVertexArrayOES(null);
        vao.elementLength = elementLength;
        vao.arrayBuffer = arrayBuffer;
        vao.elementBuffer = elementBuffer;
        return vao;
    }

    // éåä¸è§å½¢
    static backTriangle(array, next) {
        const last = array[array.length - 1];
        array.push(last);
        array.push(next);
        // array.push(next);
    }
}
VaoHelper.cache = {};
// function drawLerc3d(painter, sourceCache, layer, coords) {
//     drawLerc(painter, sourceCache, layer, coords,
//         {
//             programName: 'lerc-3d',
//             bindOtherParamFunc: bindLerc3dParams,
//             drawFunc: drawLerc3dFunc,
//             geojsonMask: false,
//         }
//     );

// }
function drawRaster(painter: Painter, sourceCache: SourceCache, layer: RasterStyleLayer, coords: Array<OverscaledTileID>) {
    if (painter.renderPass !== 'translucent') return;
    if (layer.paint.get('raster-opacity') === 0) return;

    const context = painter.context;
    const gl = context.gl;
    const source = sourceCache.getSource();
    const program = painter.useProgram('lerc-3d');

    context.program.set(program.program);
    context.setStencilMode(StencilMode.disabled);
    context.setColorMode(painter.colorModeForRenderPass());
    // context.depthTest.set(true);
    // context.depthMask.set(layer.paint.get('raster-opacity') === 1);
    // // Change depth function to prevent double drawing in areas where tiles overlap.
    // context.depthFunc.set(gl.LESS);

    // context.stencilTest.set(false);


    const sourceId = layer.paint.get('texture-source');
    const textureType = parseInt(layer.paint.get("texture-type"));

    gl.uniform1f(program.uniforms.u_opacity, layer.paint.get('raster-opacity'));
    // é¢è²å¼å
    gl.uniform1f(program.uniforms.u_domain_max, layer.paint.get("raster-domain-max"));
    gl.uniform1f(program.uniforms.u_domain_min, layer.paint.get("raster-domain-min"));

    // lercä¸ä¸é
    gl.uniform1f(program.uniforms.u_clamp_high, layer.paint.get("lerc-clamp-high"));
    gl.uniform1f(program.uniforms.u_clamp_low, layer.paint.get("lerc-clamp-low"));

    const clampHighValue = layer.paint.get("clamp-high-value") !== undefined ? layer.paint.get("clamp-high-value") : layer.paint.get("raster-domain-max");
    const clampLowValue = layer.paint.get("clamp-low-value") !== undefined ? layer.paint.get("clamp-low-value") : layer.paint.get("raster-domain-min");
    gl.uniform1f(program.uniforms.u_clamp_high_value, clampHighValue);
    gl.uniform1f(program.uniforms.u_clamp_low_value, clampLowValue);

    gl.uniform1f(program.uniforms.u_height_base, layer.paint.get("height-base"));
    gl.uniform1f(program.uniforms.u_height_factor, layer.paint.get("height-factor"));
    gl.uniform1f(program.uniforms.u_tile_size, 256);
    const zoom = sourceCache.map.getZoom();
    gl.uniform1f(program.uniforms.u_zoom, zoom);

    const rasterColor = layer.getPaintProperty("raster-colorscale");
    const textureScale = RenderRaster.bind(context).getTexture(rasterColor);

    if (textureScale) {
        gl.activeTexture(gl.TEXTURE1);
        gl.bindTexture(gl.TEXTURE_2D, textureScale);
        gl.uniform1i(program.uniforms.u_textureScale, 1);
    }
    gl.uniform1f(program.uniforms.u_tile_size, 256);
    gl.uniform1i(program.uniforms.u_texture_type, textureType);

    const minTileZ = coords.length && coords[0].overscaledZ;
    if (source instanceof ImageSource) {
        gl.uniform1i(program.uniforms.u_image_source, 1);
        gl.uniformMatrix3fv(program.uniforms.u_offset_matrix, false, source.offsetMatrix);
    } else {
        gl.uniform1i(program.uniforms.u_image_source, 0);
    }
    for (const coord of coords) {
        // if (textureScale) {
        //     gl.activeTexture(gl.TEXTURE1);
        //     gl.bindTexture(gl.TEXTURE_2D, textureScale);
        //     gl.uniform1i(program.uniforms.u_textureScale, 1);
        // }
        // set the lower zoom level to sublayer 0, and higher zoom levels to higher sublayers
        context.setDepthMode(painter.depthModeForSublayer(coord.overscaledZ - minTileZ,
            layer.paint.get('raster-opacity') === 1 ? DepthMode.ReadWrite : DepthMode.ReadOnly, gl.LESS));

        const tile = sourceCache.getTile(coord);
        const posMatrix = painter.transform.calculatePosMatrix(coord.toUnwrapped());

        tile.registerFadeDuration(layer.paint.get('raster-fade-duration'));

        gl.uniformMatrix4fv(program.uniforms.u_matrix, false, posMatrix);

        const textureColor = getRasterTexture(sourceCache, layer, coord);

        // æ¯å¦å¨ä¸è§ç½ä¸è´´çº¹ç 
        const flag = sourceId && !textureColor && textureType === 0;
        if (!flag && textureColor) {
            gl.activeTexture(gl.TEXTURE2);
            gl.bindTexture(gl.TEXTURE_2D, textureColor);
            gl.uniform1i(program.uniforms.u_texture_color, 2);

        }
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, tile.texture);
        gl.uniform1i(program.uniforms.u_image, 0);

        const vao = VaoHelper.bind(gl, program.program).getVao({ tileSize: 256, pixels: Math.round(layer.paint.get("pixels")), vertexType: layer.paint.get('vertex-type') });
        gl.extVertexArrayObject.bindVertexArrayOES(vao);
        gl.drawElements(gl.TRIANGLE_STRIP, vao.elementLength, gl.UNSIGNED_SHORT, 0);
    }

    context.depthFunc.set(gl.LEQUAL);
}


// function bindLerc3dParams(gl, program, layer, tile, sourceCache, coord) {
//     gl.uniform1f(program.uniforms.u_height_base, layer.paint.get("height-base"));
//     gl.uniform1f(program.uniforms.u_height_factor, layer.paint.get("height-factor"));
//     gl.uniform1f(program.uniforms.u_tile_size, 256);
//     const zoom = sourceCache.map.getZoom();
//     gl.uniform1f(program.uniforms.u_zoom, zoom);
//     const textureColor = getRasterTexture(sourceCache, layer, coord);
//     if (textureColor) {
//         gl.activeTexture(gl.TEXTURE2);
//         gl.bindTexture(gl.TEXTURE_2D, textureColor);
//         gl.uniform1i(program.uniforms.u_texture_color, 2);
//     }
//     gl.uniform1i(program.uniforms.u_texture_type, parseInt(layer.paint.get("texture-type")));
//     gl.activeTexture(gl.TEXTURE0);
//     gl.bindTexture(gl.TEXTURE_2D, tile.texture);
//     gl.uniform1i(program.uniforms.u_image, 0);
//     gl.uniform1f(program.uniforms.u_tile_size, 256);

//     const vao = VaoHelper.bind(gl, program.program).getVao({ tileSize: 256, pixels: Math.round(layer.paint.get("pixels")) });
//     gl.extVertexArrayObject.bindVertexArrayOES(vao);
//     gl.drawElements(gl.TRIANGLE_STRIP, vao.elementLength, gl.UNSIGNED_SHORT, 0);
// }

// function drawLerc3dFunc({gl, program, layer}) {
//     const vao = VaoHelper.bind(gl, program.program).getVao({ tileSize: 256, pixels: Math.round(layer.paint.get("pixels")) });
//     gl.extVertexArrayObject.bindVertexArrayOES(vao);
//     gl.drawElements(gl.TRIANGLE_STRIP, vao.elementLength, gl.UNSIGNED_SHORT, 0);
//     gl.clear(gl.STENCIL_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
// }

function getRasterTexture(sourceCache, layer, coord) {
    let rasterTexture;
    const sourceId = layer.paint.get('texture-source');
    if (!sourceId) {
        return rasterTexture;
    }
    const rasterSourceCache = sourceCache.style.sourceCaches[sourceId];
    if (!rasterSourceCache) {
        return rasterTexture;
    }
    const tile = rasterSourceCache.getTile(coord);
    if (tile && tile.texture && tile.texture.texture) {
        rasterTexture = tile.texture.texture;
    } else {
        rasterTexture = null;
    }
    return rasterTexture;
}
